module.exports = __webpack_public_path__ + "img/tcndxq_img4-6.5a8252c4.png";